module.exports = __webpack_public_path__ + "static/media/industria-newmobile.04bb56aa.jpg";